import tmhRequest from '@/config/tmhRequest'

export default {
    createMyCardFreeze: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycardfreeze/createmycardfreeze',
            method: 'get',
            params: data,
        })
    },

    cancelMyCardFreeze: function (data) {
        return tmhRequest({
            url: '/customer/tmh/mycardfreeze/cancelmycardfreeze',
            method: 'get',
            params: data,
        })
    },

}


// WEBPACK FOOTER //
// ./src/api/tmh/customer/mycardfreeze.js